// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Wrap":"Wrap","HeroBlock":"HeroBlock","Title":"Title","SubTitle":"SubTitle","Form":"Form","Field":"Field","Image":"Image","HeroContent":"HeroContent","HeroInner":"HeroInner","Alternate":"Alternate","HeroHeading":"HeroHeading"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/GeneralPlanning/components/Hero/css/Hero.styl
// module id = 558
// module chunks = 0